var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.reply),function(item){return _c('b-card',{key:item.id,attrs:{"sub-title":item.label}},[_c('b-card-text',[_vm._v("\n      "+_vm._s(_vm.parseResponse(item))+"\n    ")])],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }